import createHolidaysHelper from "@/helpers/holidays";
import { useContext, useState, createContext, useEffect } from "react";

const AppContext = createContext({
    isHoliday: (date = new Date()) => {return Boolean()}
});

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children, ...props }) => {
    const isHoliday = (date = new Date()) => {
        const helper = createHolidaysHelper(props.initialPage.props?.holidays);
        return helper.isHoliday(date)
    }

    return (
        <AppContext.Provider value={{
            isHoliday
        }}>
            {children}
        </AppContext.Provider>
    )
}

export default AppContext;
